// extracted by mini-css-extract-plugin
export default {"backGroundPicture":"colors_backGroundPicture__aod4j","h3":"colors_h3__M8Upu"};